import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { iframeResizer } from 'iframe-resizer';

@Component({
    selector: 'app-support',
    templateUrl: './support.component.html',
    styleUrls: ['./support.component.scss'],
})
export class SupportComponent {
    constructor(public activeModal: NgbActiveModal) {}

    accordion() {
        setTimeout(() => {
            const iframe = document.getElementById('support-frame');

            if (iframe) {
                iframe.style.border = '0';
                iframe.style.width = '100%';

                iframe.onload = () => {
                    iframeResizer({ log: true }, iframe);
                };
            }
        }, 0);
    }

    showIntercom() {
        if (window['Intercom']) {
            Intercom('boot', { app_id: 'p4t7zgsg' });
            Intercom('showNewMessage');
        }
    }
}
